import type { LocateCommandType } from './types/RobotCleaningControl.types';
import type { IState } from 'app/cross-cutting-concerns/state-management/interfaces/IState';
import type { Optional } from 'lib/types/Optional';
import type { BRangeCleaningCommandType } from 'app/cross-cutting-concerns/communication/interfaces/pra-api-graphql';

export const selectRobotCleaningControlIsLoading = (state: IState): boolean =>
  state.modules['machine-inventory']['robot-cleaning-control'].isLoading;

export const selectRobotCleaningControlPendingCommandType = (state: IState): Optional<BRangeCleaningCommandType> =>
  state.modules['machine-inventory']['robot-cleaning-control'].pendingCommandType;

export const selectRobotCleaningControlError = (state: IState): Optional<unknown> =>
  state.modules['machine-inventory']['robot-cleaning-control'].error;

export const selectRobotCleaningControlErrorCommandType = (state: IState): Optional<BRangeCleaningCommandType> =>
  state.modules['machine-inventory']['robot-cleaning-control'].errorCommandType;

export const selectRobotCleaningControlIsPaused = (state: IState): boolean =>
  state.modules['machine-inventory']['robot-cleaning-control'].isPaused === true;

/** False until the paused state has been reported once. */
export const selectRobotCleaningControlIsPausedResolved = (state: IState): boolean =>
  state.modules['machine-inventory']['robot-cleaning-control'].isPaused !== null;

export const selectRobotCleaningControlPendingLocateCommand = (state: IState): Optional<LocateCommandType> =>
  state.modules['machine-inventory']['robot-cleaning-control'].pendingLocateCommand;

export const selectRobotCleaningControlIsBeepOn = (state: IState): boolean =>
  state.modules['machine-inventory']['robot-cleaning-control'].isBeepOn === true;

export const selectRobotCleaningControlIsBlinkOn = (state: IState): boolean =>
  state.modules['machine-inventory']['robot-cleaning-control'].isBlinkOn === true;

/** False until the device has reported Beep / Blink once, so a press can't act on a guessed state. */
export const selectRobotCleaningControlIsLocateSettingsResolved = (state: IState): boolean =>
  state.modules['machine-inventory']['robot-cleaning-control'].isBeepOn !== null &&
  state.modules['machine-inventory']['robot-cleaning-control'].isBlinkOn !== null;

export const selectRobotCleaningControlLastRouteSkippedTaskId = (state: IState): Optional<string> =>
  state.modules['machine-inventory']['robot-cleaning-control'].lastRouteSkippedTaskId;

export const selectRobotCleaningControlPraDeviceId = (state: IState): Optional<string> =>
  state.modules['machine-inventory']['robot-cleaning-control'].praDeviceId;
